import React from "react";
import { Link } from "react-router-dom";
import data from "../data/data";
import { StyledHero } from "../components/Styled";

const About = () => {
  const skills = [...data.skills[0].professional];
  const skillBars = [...data.skills[0].bars];
  const experience = [...data.experience];
  const education = [...data.education];
  const certifications = [...data.certifications];

  return (
    <div className="page-height about">
      <StyledHero>
        <h3>About Me</h3>
        <p>
          <Link to="/">Home</Link> / About Me
        </p>
      </StyledHero>
      <div className="section-one">
        <div className="about-info">
          <h2>About Myself</h2>
          <p>
            I am a highly motivated and self driven individual who takes every
            opportunity given and fully utilize the great skills and potential
            to develop new competence, accountability, responsibility and
            experience with an approach to problem solving and resolution to
            deliver more than expected.
          </p>
          <h2>Proffesional Skills</h2>
          <ul>
            {skills.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="skills-info">
          {skillBars.map((item, index) => (
            <li key={index}>
              <h3>{item.title}</h3>
              <span className="bar">
                <span className={item["bar-class"]}></span>
              </span>
            </li>
          ))}
        </div>
      </div>
      <div className="section-two">
        <div className="experience">
          <h2>Experience</h2>
          {experience.map((item, index) => (
            <div key={index}>
              <h3 className="title">{item.title}</h3>
              <h6 className="date">{item.date}</h6>
              <h5>Duties</h5>
              <ul>
                {item.duties.map((duty, index) => (
                  <li key={index}>{duty}</li>
                ))}
              </ul>
            </div>
          ))}
          <span></span>
          <span></span>
        </div>
        <div className="education">
          <div>
            <h2>Education</h2>
            {education.map((item, index) => (
              <div key={index}>
                <h3 className="institution">{item.institution}</h3>
                <h5 className="date">{item.date}</h5>
                <h3 className="title">{item.title}</h3>
              </div>
            ))}
          </div>

          <div>
            <h2>Certifications</h2>
            {certifications.map((item, index) => (
              <div key={index}>
                <h3 className="institution">{item.institution}</h3>
                <h5 className="date">{item.date}</h5>
                <h5 className="title">{item.cert_id}</h5>
                <h3 className="title">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
